module.exports = __webpack_public_path__ + "static/img/slogen-page.7134d393.png";